import SettingsViewWrapper from '@/shared/components/SettingsViewWrapper/SettingsViewWrapper';
import { helpInfoItems } from '@/shared/config/helpInfoItems';
import { IonItem, IonItemGroup, IonRouterLink } from '@ionic/react';
import React from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import style from './Helpinfo.module.css';
import _ from 'lodash';
import { useHistory } from 'react-router';

const HelpInfo: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <SettingsViewWrapper name="help-page" title={t('general.help.info')}>
      {helpInfoItems.map(({ title, items }) => (
        <IonItemGroup key={title} class={style.group}>
          <IonItem lines="none">
            <h3>{t(title)}</h3>
          </IonItem>
          {items.map(({ text, link }) => (
            <IonItem lines="none" key={t(text)} detail={false}>
              <IonRouterLink
                href={link}
                target={_.startsWith(link, '/') ? '_self' : '_blank'}
                onClick={(evt) => {
                  if (_.startsWith(link, '/')) {
                    evt.preventDefault();
                    history.push(link);
                  }
                }}
              >
                {t(text)}
              </IonRouterLink>
            </IonItem>
          ))}
        </IonItemGroup>
      ))}
    </SettingsViewWrapper>
  );
};

export default withTranslation()(HelpInfo);
